import {
    AfterViewInit,
    Component,
    Input,
    OnDestroy,
    OnInit
} from '@angular/core';
import { ResumeUpdaterService } from '../services/cart-resume-updater.service';
import { ToastrService } from 'ngx-toastr';
import { TranslateService } from '@ngx-translate/core';
import { DeliveryStepsService } from '../../payment/services/delivery-steps.service';
import { CartItem } from '../../shared/components/abstract-item-row/abstract-item-row';
import { AutoUnsubscribe } from 'ngx-auto-unsubscribe';
import { Subscription } from 'rxjs/Subscription';

@AutoUnsubscribe()
@Component({
    selector: 'cart-resume',
    templateUrl: './cart.resume.component.html',
    styleUrls: []
})
export class CartResumeComponent implements AfterViewInit, OnInit, OnDestroy {
    @Input('items') items: Array<CartItem> = [];

    public discount: number;
    public subtotal: number;
    public freight: number;
    public total: number;

    resumeUpdaterServiceInvalidCoupon: Subscription;
    resumeUpdaterServiceIndexed: Subscription;

    constructor(
        protected resumeUpdaterService: ResumeUpdaterService,
        protected toastr: ToastrService,
        protected translate: TranslateService,
        protected deliveryStepsService: DeliveryStepsService
    ) { }

    ngOnInit() {
        this.resumeUpdaterServiceInvalidCoupon = this.resumeUpdaterService.invalidCoupon$.subscribe(() => {
            this.translate
            .get([
                'CART.ROW.ERRORS.INVALID_COUPON.TITLE',
                'CART.ROW.ERRORS.INVALID_COUPON.MESSAGE'
            ])
            .subscribe(translated => {
                this.toastr.error(
                    translated['CART.ROW.ERRORS.INVALID_COUPON.MESSAGE'],
                    translated['CART.ROW.ERRORS.INVALID_COUPON.TITLE'],
                    {}
                );
            });
        });
        this.resumeUpdaterServiceIndexed = this.resumeUpdaterService.indexed$.subscribe((index: any) => {
            this.discount = index.discount;
            this.subtotal = index.subtotal;
            this.freight = index.freight;
            this.total = index.total;
        });
    }
    ngAfterViewInit() {
        this.resumeUpdaterService.refresh().subscribe();
    }
    ngOnDestroy() {
        // Overrided by AutoUnsubscribe
    }

    /** Cart is deliverable if at least one item is deliverable */
    public isDeliverable() {
        return this.items.filter(cartItem => {
            return cartItem.attributes.deliverable;
        }).length > 0;
    }
}



// WEBPACK FOOTER //
// /codebuild/output/src3659550778/src/src/app/cart/resume/cart.resume.component.ts